{
    "东": 1,
    "冬": 1,
    "江": 1,
    "支": 1,
    "微": 1,
    "鱼": 2,
    "虞": 2,
    "齐": 2,
    "佳": 1,
    "灰": 1,
    "真": 1,
    "文": 2,
    "元": 2,
    "寒": 2,
    "删": 1,
    "先": 1,
    "萧": 1,
    "肴": 2,
    "豪": 2,
    "歌": 1,
    "麻": 2,
    "阳": 2,
    "庚": 1,
    "青": 1,
    "蒸": 1,
    "尤": 2,
    "侵": 1,
    "覃": 2,
    "盐": 2,
    "咸": 2,
    "董": 3,
    "肿": 3,
    "讲": 3,
    "纸": 3,
    "尾": 3,
    "语": 3,
    "麌": 3,
    "荠": 4,
    "蟹": 4,
    "贿": 4,
    "轸": 3,
    "吻": 3,
    "阮": 3,
    "旱": 4,
    "潸": 1,
    "铣": 3,
    "筱": 3,
    "巧": 3,
    "皓": 4,
    "哿": 3,
    "马": 3,
    "养": 3,
    "梗": 3,
    "迥": 3,
    "有": 3,
    "寝": 3,
    "感": 3,
    "俭": 3,
    "豏": 4,
    "送": 4,
    "宋": 4,
    "绛": 4,
    "寘": 4,
    "未": 4,
    "御": 4,
    "遇": 4,
    "霁": 4,
    "泰": 4,
    "卦": 4,
    "队": 4,
    "震": 4,
    "问": 4,
    "愿": 4,
    "翰": 4,
    "谏": 4,
    "霰": 3,
    "啸": 4,
    "效": 4,
    "号": 4,
    "个": 4,
    "祃": 4,
    "漾": 4,
    "敬": 4,
    "径": 4,
    "宥": 4,
    "沁": 4,
    "勘": 1,
    "艳": 4,
    "陷": 4,
    "屋": 1,
    "沃": 4,
    "觉": 2,
    "质": 4,
    "物": 4,
    "月": 4,
    "曷": 2,
    "黠": 2,
    "屑": 4,
    "药": 4,
    "陌": 4,
    "锡": 1,
    "职": 2,
    "缉": 1,
    "合": 2,
    "叶": 4,
    "洽": 4
}